/* istanbul ignore file */
import { css } from 'styled-components';

import { DRAWER_HEIGHT_CSS_VAR } from '../constants/cssVariables';

export const container = css`
  display: flex;
  flex-direction: column;
  height: var(${DRAWER_HEIGHT_CSS_VAR});
  min-height: 100%;
`;
